

















































































































































import {Component, Vue} from 'vue-property-decorator';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import SenderSelector from '@/components/user/SenderSelector.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';

import {loginModule} from '@/store/authentication/login';
import moment from 'moment';

import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import {progress} from '@/script/progress';

import {商品区分一覧, 商品区分型} from '@/type/destroy/types/商品区分型';
import {部署型} from '@/type/department/department';
import {破棄破損履歴検索条件型} from '@/type/destroy/records/history/破棄破損履歴検索条件型';
import {破棄破損履歴検索結果型, 破棄破損履歴検索結果返却型} from '@/type/destroy/records/history/破棄破損履歴検索結果型';
import 破棄破損履歴検索条件入力チェッカー from '@/type/destroy/records/history/破棄破損履歴検索条件入力チェッカー';

@Component({
  components: {
    NormalButton,
    ConfirmDialog,
    DepartmentSelector,
    Datepicker,
    ButtonPanel,
    IconButton,
    SenderSelector,
    AlertDialog,
  },
  filters: {
    日付のフォーマット(date: Date): string | null {
      if (!date) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
  },
})
export default class ReferenceDestroy extends Vue {
  // data
  在庫場所一覧: 部署型[] = [];

  検索条件: 破棄破損履歴検索条件型 = this.デフォルトの検索条件;
  検索結果: 破棄破損履歴検索結果型[] = [];

  選択行番号: number | null = null;
  アラートメッセージ: string[] | string | null = null;

  // computed
  get ログインユーザの部署コード(): string {
    return loginModule.部署コードを取得する;
  }

  get ログインユーザの利用者コード(): string {
    return loginModule.利用者コードを取得する;
  }

  get 管理者である(): boolean {
    return loginModule.管理者である;
  }

  get 代行ログインである(): boolean {
    return loginModule.マスターである;
  }

  get バラ管理である(): boolean {
    return loginModule.バラ管理である;
  }

  get 有効期限管理をする(): boolean {
    return loginModule.有効期限管理をする;
  }

  get 渓仁会仕様である(): boolean {
    return loginModule.渓仁会仕様である;
  }

  get 表示件数(): number {
    return this.検索結果.length;
  }

  get 商品区分一覧(): 商品区分型[] {
    return 商品区分一覧;
  }

  get デフォルトの検索条件(): 破棄破損履歴検索条件型 {
    return {
      破棄破損日FROM: moment().startOf('month').toDate(),
      破棄破損日TO: null,
      商品区分: null,
      メーカー名: null,
      商品名カナ: null,
      在庫場所: this.ログインユーザの部署コード,
      データ登録者: this.管理者である ? null : this.ログインユーザの利用者コード,
    };
  }

  // methods
  検索条件入力エラー判定表示(項目名: string) {
    return {'input-error': this.検索条件入力エラー判定(項目名)};
  }

  検索条件入力エラー判定(項目名: string): boolean {
    const checker = new 破棄破損履歴検索条件入力チェッカー(this.検索条件);
    return checker.hasError(項目名);
  }

  行が選択されている(行番号: number): boolean {
    if (this.選択行番号 === null) {
      return false;
    }
    return this.選択行番号 === 行番号;
  }

  行を選択する(行番号: number): void {
    this.選択行番号 = 行番号;
  }

  Excel出力確認ダイアログを開く(): void {
    this.$modal.show('Excel出力確認ダイアログ');
  }

  Excel出力確認ダイアログを閉じる(): void {
    this.$modal.hide('Excel出力確認ダイアログ');
  }

  async 破棄破損履歴を検索する(): Promise<void> {
    const checker = new 破棄破損履歴検索条件入力チェッカー(this.検索条件);
    if (checker.hasErrors()) {
      this.alert(checker.errorMessages());
      return;
    }

    const 検索処理 = async (): Promise<void> => {
      await api.破棄破損履歴を検索する(this.検索条件)
        .then((response: 破棄破損履歴検索結果返却型) => {
          this.検索結果 = response.破棄破損履歴検索結果返却レコード一覧;
          if (this.検索結果.length === 0) {
            this.alert('検索結果が0件です。');
            return;
          }
          if (response.アラートメッセージ) {
            this.alert(response.アラートメッセージ);
          }
        }).catch((error: any) => {
          this.alert(error.data.message);
        });
    };

    await progress(検索処理);
  }

  async Excelファイル出力前入力チェックをする(): Promise<void> {
    const checker = new 破棄破損履歴検索条件入力チェッカー(this.検索条件);
    if (checker.hasErrors()) {
      this.alert(checker.errorMessages());
      return;
    }
    this.Excel出力確認ダイアログを開く();
  }

  async Excelファイルを出力する(): Promise<void> {
    const Excel出力処理 = async (): Promise<void> => {
      await download.破棄破損履歴照会一覧表を出力する('破棄破損履歴照会一覧表.xlsx', this.検索条件)
        .catch((error: any) => {
          this.alert(error.data.message);
        });
    };

    await progress(Excel出力処理);
    this.Excel出力確認ダイアログを閉じる();
  }

  alert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('破棄破損履歴照会アラート');
  }

  // lifecycle hooks
  async created(): Promise<void> {
    await api.部署一覧を取得する()
      .then((response: 部署型[]) => {
        this.在庫場所一覧 = response;
      })
      .catch((error: any) => {
        this.在庫場所一覧 = [];
        this.alert(error.data.message);
      });
  }
}
